/* PWA registration + install prompt + online/offline state.
 *
 * Используется в index.js/App.js — регистрирует service worker
 * и хранит deferredPrompt для последующего показа кнопки «Установить».
 */

let deferredInstallPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach((cb) => cb({
    canInstall: !!deferredInstallPrompt,
    online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  }));
}

export function subscribePwaState(cb) {
  listeners.add(cb);
  // отдаём текущее состояние сразу
  cb({
    canInstall: !!deferredInstallPrompt,
    online: typeof navigator !== 'undefined' ? navigator.onLine : true,
  });
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredInstallPrompt) return { outcome: 'unavailable' };
  deferredInstallPrompt.prompt();
  const choice = await deferredInstallPrompt.userChoice;
  deferredInstallPrompt = null;
  notify();
  return choice;
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    // iOS Safari
    window.navigator.standalone === true
  );
}

export function isIos() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || '');
}

export function registerPwa() {
  if (typeof window === 'undefined') return;

  // 1) Регистрация service worker (только в production-сборке).
  // Для dev (CRA `react-scripts start`) — не регистрируем, иначе ломает HMR.
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          // Подписываемся на обновления — если появился новый SW в waiting,
          // активируем его немедленно (чтобы у пользователя всегда был свежий).
          if (reg.waiting) reg.waiting.postMessage('SKIP_WAITING');
          reg.addEventListener('updatefound', () => {
            const installing = reg.installing;
            if (!installing) return;
            installing.addEventListener('statechange', () => {
              if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                installing.postMessage('SKIP_WAITING');
              }
            });
          });
        })
        .catch(() => { /* тихо игнорируем */ });

      // При смене активного SW — перезагружаем страницу один раз,
      // чтобы взять свежий шелл (без зацикливания).
      let refreshed = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshed) return;
        refreshed = true;
        window.location.reload();
      });
    });
  }

  // 2) Перехватываем beforeinstallprompt (Android/Chrome) — браузер выдаёт
  // его, когда сайт удовлетворяет PWA-критериям. Мы откладываем показ
  // системного диалога и показываем нашу кнопку.
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    notify();
  });

  // 3) online / offline события
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
}
